import React from "react";
import SbEditable from "storyblok-react";
import RichText from "/src/utils/RichText";
import { TitleColour } from "/src/utils/ColourUtilities";
import LinkStyle from "src/utils/LinkStyle";

const SimpleCentered = ({ blok }) => {
  const heading =
    blok.content_type === "magazine" ? (
      <h1
        className={`font-insights-display text-lg font-semibold leading-5`}
        style={{ color: blok.primary_colour }}
      >
        {blok.title}
      </h1>
    ) : (
      <h1
        className={`font-display uppercase ${
          blok.big_title
            ? "text-6xl !leading-[3rem] sm:text-8xl sm:!leading-[5rem]"
            : "text-4xl !leading-8 sm:text-5xl sm:!leading-10"
        } ${TitleColour(blok.colour)}`}
      >
        {blok.title}
      </h1>
    );

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="bg-white">
        <div
          className={`mx-auto my-16 max-w-7xl ${
            blok.center_content ? "" : "sm:my-16"
          } px-6 ${blok.remove_top_padding && "!pt-0"} ${
            blok.remove_margin ? "!my-0" : ""
          }`}
        >
          <div
            className={`${
              blok.center_content ? "mx-auto max-w-2xl" : "max-w-3xl"
            }`}
          >
            {heading}
            <div
              className={`text-darkgrey prose mt-5 text-sm prose-${
                blok._uid
              } max-w-full ${
                blok.content_type === "magazine"
                  ? "font-insights-body"
                  : "font-body"
              } ${blok.center_content ? "text-center" : ""}`}
            >
              <RichText>{blok.content}</RichText>
            </div>
          </div>
        </div>
      </div>
      <LinkStyle {...blok} />
    </SbEditable>
  );
};

export default SimpleCentered;
